import { render, staticRenderFns } from "./banner-designs.vue?vue&type=template&id=52c1e3f0&scoped=true"
import script from "./banner-designs.vue?vue&type=script&lang=js"
export * from "./banner-designs.vue?vue&type=script&lang=js"
import style0 from "./banner-designs.vue?vue&type=style&index=0&id=52c1e3f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c1e3f0",
  null
  
)

export default component.exports